export default {
  getBuyList: state => state.buyList,
  getEmoticonList: state => state.emoticonList
};
